import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import SuccessWrapper from "./Success.style";

import summary_section_img from "../../../../assets/images/icons/summary-section-img.svg"
import copy_input_icon from "../../../../assets/images/icons/copy-input-icon.svg"
import appstore_btn from "../../../../assets/images/appstore-btn.png"
import googleplay_btn from "../../../../assets/images/googleplay-btn.png"
// import appgallery_btn from "../../../assets/images/appgallery-btn.png"
import { useLocation ,useSearchParams} from "react-router-dom";
import * as renewalServices from '../../../../services/renewal-service';
import * as globalUtils from '../../../../helpers/utils';
import HomeInsurancePromoMsg from "../../../../_shared/HomeInsurancePromoMsg/HomeInsurancePromoMsg";

const Success = (props) => {
    const location = useLocation();
    const [paymentType,setPaymentType] = useState(location.state ? 'Sadad' : '');

    const [policyNumber,setPolicyNumber] = useState(location.state ? location.state.policyNumber : "");
    const [amount,setAmount] = useState(location.state ? location.state.amount : "");
    const [billNumber,setBillNumber] = useState(location.state ? location.state.billNumber : "");
    const [searchParams, setSearchParams] = useSearchParams();
    const creditCardSessionID = searchParams.get("cko-session-id");
    const refId = searchParams.get("refId");
    const { t, i18n } = useTranslation();


    useEffect(()=>{
      if(creditCardSessionID){
        renewalServices.getPaymentById({id : creditCardSessionID}).then((response) =>{
          const data = response.data;
          setPolicyNumber(data.policyNo);
          setAmount(data.getPaymentDetailsByIdResponse.amount);
          setPaymentType("Credit Card")
        })
      }
      ForDomesticTage()

    },[creditCardSessionID]);



    const ForDomesticTage = ()=>{
     let ChangeVal=  JSON.parse(localStorage.getItem("checkout"))
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(ChangeVal);   
  }

  console.log(props,"FFF")
    useEffect(()=>{
      if(refId){
        const data = {
          "systemId":"MOTOR",
          "applicationType":"RHSP",
          "langCode":globalUtils.getOneLetterLanguageCode(props.i18n.language),
          "referenceId":refId,
          "channelCode":"85"
      };
        renewalServices.verifyTamaraOrder(data).then((response) =>{
          if(response.data.resultCode == "S"){
            setPolicyNumber(response.data.policyNumber);
            setAmount(response.data.totalAmount);
            setPaymentType("Tamara");
          }
        })
      }
    },[refId])


  return (
    <SuccessWrapper>
      <div className="payment-details-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="header-wrapper">
                <div className="text">
                  <h1>Thank you for choosing Tawuniya</h1>
                  <p>
                    You can pay via ATM or Bank and the policy will be activated
                    after the payment
                  </p>
                </div>
                <div className="image">
                  <img
                    src={summary_section_img}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row row-flex">
            <div className="col-md-6">
              <div className="sadad-table content">
                <div className="table-header">
                  <h3>{paymentType} Details</h3>
                  <img src="assets/images/icons/Sadad-payment.svg" alt="" />
                </div>
                <div className="table-body">
                  <div className="cell">
                    <div className="text">
                      <p>Policy Number</p>
                    </div>
                    <div className="description">
                      <p>{policyNumber}</p>
                      <img
                        src={copy_input_icon}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="cell">
                    <div className="text">
                      <p>Payment Amount</p>
                    </div>
                    <div className="description">
                      <p>{amount}</p>
                      <img
                        src={copy_input_icon}
                        alt=""
                      />
                    </div>
                  </div>
                  {billNumber && <div className="cell">
                    <div className="text">
                      <p>Policy Bill Number</p>
                    </div>
                    <div className="description">
                      <p>{billNumber}</p>
                      <img
                        src={copy_input_icon}
                        alt=""
                      />
                    </div>
                  </div>}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="sadad-table content">
                <div className="table-header">
                  <h3>What happens next</h3>
                </div>
                <div className="table-body">
                  <div className="cell">
                    <div className="description active">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2 12.266c0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10s-10-4.478-10-10zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.85l-1.293-1.293a1 1 0 0 0-1.414 1.415l2 2a1 1 0 0 0 1.414 0l4-4z"
                          fill="#4c565c"
                        />
                      </svg>
                      <p>
                        Policy will be issued automatically and sent to your
                        email.
                      </p>
                    </div>
                  </div>
                  <div className="cell">
                    <div className="description">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2 12.266c0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10s-10-4.478-10-10zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.85l-1.293-1.293a1 1 0 0 0-1.414 1.415l2 2a1 1 0 0 0 1.414 0l4-4z"
                          fill="#4c565c"
                        />
                      </svg>
                      <p>Policy will be uploaded to Najm instantly.</p>
                    </div>
                  </div>
                  <div className="cell">
                    <div className="description">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2 12.266c0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10s-10-4.478-10-10zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.85l-1.293-1.293a1 1 0 0 0-1.414 1.415l2 2a1 1 0 0 0 1.414 0l4-4z"
                          fill="#4c565c"
                        />
                      </svg>
                      <p>
                        Download our mobile app and register for online services
                      </p>
                    </div>
                  </div>
                  <div className="store-link">
                    <img src={appstore_btn} alt="" />
                    <img src={googleplay_btn} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <HomeInsurancePromoMsg text={t('HomeInsurancePromoMsgSadad')}/> */}
        </div>
      </div>
    </SuccessWrapper>
  );
};

export default withTranslation()(Success);
